import i18next, { i18n } from 'i18next';
import i18nBackend from 'i18next-http-backend';
import { App } from 'vue';
export type I18nService = i18n;

const translationApi =
  'https://i18n-api.oneweb.mercedes-benz.com/projects/24c9c23986d889746abead6ded32eb0c/locales/{{lng}}/download?file_format=i18next';

export async function createI18nService(locale: string, app: App) {
  const i18nextInstance = i18next.createInstance();

  app.config.globalProperties.$t = i18nextInstance.t.bind(i18next);
  await i18nextInstance.use(i18nBackend).init({
    backend: {
      loadPath: translationApi,
      parse: (data: string) => JSON.parse(data),
    },
    lng: locale,
    returnEmptyString: false,
    parseMissingKeyHandler: (key) => key, // Return the key of missing translations
  });

  return i18nextInstance;
}
